'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getScreenSaver(this.$stateParams.id);
  }

  getScreenSaver(id) {
    this.$http.get(`/api/screenSavers/${id}`).then(res => {
      this.saver = res.data;
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/screenSaver/show/show.controller.js